import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSMSBroadcast as UpdateSMSBroadcastMutation,
    UpdateSMSBroadcastVariables,
    SmsEditionUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_SMS_BROADCAST from '../mutations/update-sms-broadcast.graphql';
import GET_SMS_BROADCAST from '../queries/get-sms-broadcast.graphql';

export const useUpdateSMSBroadcast = (): {
    updateSMSBroadcast: (arg1: SmsEditionUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateSMSBroadcast, {loading, error}] = useMutation<
        UpdateSMSBroadcastMutation,
        UpdateSMSBroadcastVariables
    >(UPDATE_SMS_BROADCAST);

    return {
        updateSMSBroadcast: (input: SmsEditionUpdateInput) =>
            updateSMSBroadcast({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedEdition =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.smsEditionUpdate &&
                        mutationResults.data.smsEditionUpdate.edition;

                    if (!updatedEdition) return;

                    const updatedBroadcast = updatedEdition.campaign;
                    const cachedData = proxy.readQuery({
                        query: GET_SMS_BROADCAST,
                        variables: {broadcastId: updatedBroadcast.id},
                    });

                    if (cachedData) {
                        // @ts-expect-error
                        const cachedEdition = cachedData.smsBroadcast.edition;

                        proxy.writeQuery({
                            query: GET_SMS_BROADCAST,
                            variables: {broadcastId: updatedBroadcast.id},
                            data: {
                                smsBroadcast: {
                                    // @ts-expect-error
                                    ...cachedData.smsBroadcast,
                                    owner: updatedBroadcast.owner,
                                    name: updatedBroadcast.name,
                                    edition: {
                                        ...cachedEdition,
                                        ...updatedEdition,
                                    },
                                },
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
